import { BaseTheme as Theme } from '@blockanalitica/ui/package/types/src/theme/baseTheme';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function paginationLegend(theme: Theme): ComponentStyle {
  return {
    componentName: 'paginationLegend',
    baseStyle: {
      fontSize: theme.sizes['-1']
    }
  };
}
